export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/**
 * Return the URL of the in-app sign-in page. Used for unauthenticated
 * redirects from protected routes and tRPC UNAUTHORIZED errors.
 */
export const getLoginUrl = () => "/sign-in";
